module.exports = window.wooGlobal;
